<template>
    <div>
      <app-form
        v-bind:parentObject="{
          data: this.formData,
          pageTitle: this.pageTitle,
          pageTitleValue: this.pageTitleValue,
          errMsg: this.errMsg,
          isEdit: this.editMode,
          isWizard: this.wizardMode,
        }"
        v-on:input="formData = $event"
        v-on:next="nextHandler"
        v-on:save="saveHandler"
        v-on:error="errorHandler"
      />
      <div v-if="isErr">
        <app-error
          v-bind:parentError="{
            data: this.errMsg,
            isErr: this.isErr,
          }"
          v-on:closeError="isErr = $event"
        />
      </div>
    </div>
  </template>
  
  <script>
  
  import KpiSettingForm from "../../../components/performancemanagement/targetsetting/Form";
  import ErrorDialog from "../../../components/common/ErrorDialog";
  
  export default {
    components: {
      "app-form": KpiSettingForm,
      "app-error": ErrorDialog,
    },
  
    data() {
      return {
        pageTitle: this.$t('performancemanagement.kpisetting'),
        pageTitleValue: '',

        formData: {
          kpiexerid: null,
          kpiexercode: null,
          kpiexerdesc: null,
          startdate: null,
          enddate: null,
          kpiexerstatusid: null,
          kpiexerstatus: null,
          staffFirst: 0,
          pmkpiinclusionid: null,
          pmkpiinclusioncode: null,
          stamp: 0,
          userid: this.$store.getters.userId,
        },

        formDataParameter: {
          servicerecasatdate: null,
          hiredate: null,
          cessationdate: null,
          isOverwrite: false,
        },

        parameters: {
          companyid: null,
          compnyname: null,
          branchid: null,
          brchname: null,
          departmentid: null,
          deptname: null,
          divisionid: null,
          divnname: null,
          sectionid: null,
          sectioname: null,
          unitid: null,
          unitname: null,
          gradeid: null,
          grddesc: null,
          employmenttypeid: null,
          emptypecatdesc: null,
          staffid: null,
          staffcode: null,
          jobid: null,
          jobtitle: null,
        },

        errMsg: "",
        isErr: false,
        editMode: false,
        wizardMode: true,
      };
    },
  
    methods: {
  
      errorHandler($event) {
        this.isErr = $event.isErr;
        this.errMsg = $event.errMsg;
      },
  
      saveHandler() {
        
        const vm = this;

        if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
          return false;
        }

        this.$store.dispatch('post', {url: "/kpiexercise/create", payload: this.formData})
        .then((res) => {
            if (res.data.error) {
              //DEV
              vm.isErr = true; // Set error state to true
              // Format the error messages
              if (Array.isArray(res.data.error)) {
                vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
              } else {
                vm.errMsg = res.data.error;
              }
            } else {
                this.$router.push({ name: "kpisettinglist" });
            }
        })
        .catch((err) => {
            vm.isErr = !vm.isErr;
            vm.errMsg = err;
        });

      },

      nextHandler() {
        const vm = this;

        if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
          return false;
        }

        this.$store.dispatch('post', {url: "/kpiexercise/create", payload: this.formData})
        .then((res) => {
            if (res.data.error) {
              //DEV
              vm.isErr = true; // Set error state to true
              // Format the error messages
              if (Array.isArray(res.data.error)) {
                vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
              } else {
                vm.errMsg = res.data.error;
              }
            } else {
              this.formData.kpiexerid = res.data.insertId;
              this.$router.push({name: 'kpisettinggenerate', params: { formData: this.formData, formDataParameter: this.formDataParameter, parameters: this.parameters, isEdit: false} });
            }
        })
        .catch((err) => {
            vm.isErr = !vm.isErr;
            vm.errMsg = err;
        });
        
      },
    },

    created() {
      if(this.$route.params.formData !== undefined) {
        this.formData = this.$route.params.formData;
      }
      if(this.$route.params.formDataParameter !== undefined) {
        this.formDataParameter = this.$route.params.formDataParameter;
      }
      if(this.$route.params.parameters !== undefined) {
        this.parameters = this.$route.params.parameters;
      }
    }
  };
  </script>